<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' }]"
    />

    <div class="row print-no-show">
      <div class="col-6">
        <span class="mb-2 fw-bold">Detalhes do Usuário</span>
      </div>
      <div class="col-6 text-end">
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/users/new', query: { edit: true, id: dados.id } }">
          <i class="bi bi-pencil-fill me-2"></i>Editar  
        </router-link>
        <button @click="imprimir()" class="btn btn-sm btn-secondary"><i class="bi bi-printer me-2"></i>Imprimir</button>
      </div>
    </div>
    <hr class="print-no-show"/>

    <div v-if="dados.id != null" class="row">
      <div class="col mx-auto " style="margin-bottom: 40px;" id="conteudoParaImprimir">
        <div class="card">
          <div class="card-body">
            <table class="table table-striped">
              <tbody>
                <tr>
                  <td colspan="2">Usuário: {{ dados.name }}</td>
                  <td colspan="1">Level: {{ dados.level }}</td>
                </tr>
                <tr>
                  <td>Email: {{ dados.email }}</td>
                  <td>Telefone: {{ dados.phone }}</td>
                  <td>Aniversário: {{ dados.birthdate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 7rem; height: 7rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <!--  
        birthdate

        fico devendo movimentações do usuario no estoque
    -->
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, reactive } from 'vue';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { users } from '@/models/users';

export default {
  name: "DetailsView",
  components: { PainelLayout, Breadcrumb },
  setup(props) {

    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');

    const model = users();

    var dados = reactive({
      id: null,
      name: null,
      email: null,
      level: null,
      phone: null,
      birthdate: null
    });

    function imprimir() {
      window.print();
    }

    onMounted(() => {
      model.getOne(id).then((response) => {
          dados.id = response.id;
          dados.name = response.name;
          dados.email = response.email;
          dados.level = response.level;
          dados.phone = response.phone;
          dados.birthdate = response.birthdate;
      });
    });

    return {
      dados,
      imprimir
    }
  }
}
</script>

<style scoped>

  .header-print {
    display: none;
  }

  @media print {
    /* Esconde tudo no corpo */
    body * {
      visibility: hidden;
    }

    .print-no-show {
      display: none !important;
    }

    .header-print {
      display: block;
      margin-bottom: 20px;
      margin-top: -10px;
    }
    
    /* Mostra apenas a div de impressão */
    #conteudoParaImprimir, #conteudoParaImprimir * {
      visibility: visible;
    }
    
    /* Opcional: Forçar quebra de página */
    #conteudoParaImprimir p {
      page-break-inside: avoid;
    }
  }

</style>